/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_Adv_5Inputs */

const en_pc_cmp_adv_5 = /** @type {(inputs: Pc_Cmp_Adv_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A native app written in Rust, plus a browser version that needs no install.`)
};

const zh_pc_cmp_adv_5 = /** @type {(inputs: Pc_Cmp_Adv_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用 Rust 编写的原生应用，另有无需安装的浏览器版本。`)
};

/**
* | output |
* | --- |
* | "A native app written in Rust, plus a browser version that needs no install." |
*
* @param {Pc_Cmp_Adv_5Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_adv_5 = /** @type {((inputs?: Pc_Cmp_Adv_5Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_Adv_5Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_adv_5(inputs)
	return zh_pc_cmp_adv_5(inputs)
});
export { pc_cmp_adv_5 as "pc.cmp.adv.5" }